/* @flow */
import { Container } from 'flux/utils';
import React from 'react';

import AlertDialog from 'components/AlertDialog.jsx';
import Coin from 'components/Coin.jsx';
import Image from 'components/Image.jsx';
import Glyph from 'components/Glyph.jsx';
import Group from 'entities/Group';
import GroupInviteModal from 'groups/components/GroupInviteModal.jsx';
import GroupStore from 'groups/stores/GroupStore';
import schoolImage from 'assets/images/school-circle.svg';
import Organization from 'entities/Organization';
import OrganizationActions from 'actions/OrganizationActions';
import OrganizationStore from 'stores/OrganizationStore';
import YouTubeEmbed from 'components/YouTubeEmbed.jsx';
import { mountModal } from 'lib/modal';
import { VIDEO_URL } from 'admin/constants/AdminRoles';

export const SchoolCrownBadge = () =>
  <div className="AdminVerificationModal-school-image">
    <Image height="64" width="64" src={schoolImage} />
    <Coin className="AdminVerificationModal-badge" color="midnight" size="xlarge">
      <Glyph name="crown" color="white" size="xxsmall" solo />
    </Coin>
  </div>;

import './styles/AdminVerificationModal.scss';

class AdminVerifiedModal extends React.Component {
  props: {
    onRequestHide: () => any,
    orgId: number,
  }

  state: {
    org: ?Organization,
    schoolClass: ?Group,
  }

  static getStores() {
    return [GroupStore, OrganizationStore];
  }

  static calculateState(prevState, props) {
    const org = OrganizationStore.getOrganization(props.orgId);
    if (!org) {
      return {};
    }
    const schoolClass = GroupStore.getStaffClassForOrg(org.id);
    return { org, schoolClass };
  }

  componentWillMount() {
    OrganizationActions.getOrLoadOrganization(this.props.orgId);
  }

  showInviteDialog = () => {
    this.props.onRequestHide();
    if (this.state.schoolClass) {
      mountModal(<GroupInviteModal group={this.state.schoolClass} />, this);
    }
  }

  render() {
    if (!this.state.org) {
      return null;
    }

    return (
      <AlertDialog
        eventScreenName="AdminVerifiedModal"
        ref="dialog"
        size="small"
        className="AdminVerificationModal"
        hideCloseButton
        hideOnBlur={false}
        headerImageComponent={<SchoolCrownBadge />}
        title={`Welcome to ${this.state.org.getName()} on Remind!`}
        subtext="Watch the video to see what you can do as a verified administrator of your school."
        buttonText="Add teachers to your school"
        onRequestHide={this.showInviteDialog}>
        <YouTubeEmbed
          className="AdminVerificationModal-video"
          width={392}
          height={220}
          src={VIDEO_URL}
        />
      </AlertDialog>
    );
  }
}

export default Container.create(AdminVerifiedModal, {
  withProps: true,
  pure: false,
});



// WEBPACK FOOTER //
// ./src/admin/components/AdminVerifiedModal.jsx